import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  alias: Yup.mixed().nullable().required('field.error.required'),
  credits: Yup.number()
    .nullable(true)
    .transform((v, o) => (o === '' ? 0 : v)),
})
